import { getNumericDeclension } from '@culture/common-helpers/string';

/* eslint-disable id-length */
export const secondsToHMS = (seconds) => {
	const date = new Date(0);
	date.setSeconds(seconds); // specify value for SECONDS here
	const [h, m, s] = date
		.toISOString()
		.replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1')
		.split(':');

	return { hours: +h, minutes: +m, seconds: +s };
};

export const getSecondsDeclensionString = (seconds) => {
	const { hours, minutes, seconds: resultSeconds } = secondsToHMS(seconds);
	const result = [];
	if (hours) {
		result.push(
			`${+hours} ${getNumericDeclension(+hours, {
				single: 'час',
				some: 'часа',
				many: 'часов'
			})}`
		);
	}
	if (minutes) {
		result.push(
			`${+minutes} ${getNumericDeclension(+minutes, {
				single: 'минута',
				some: 'минуты',
				many: 'минут'
			})}`
		);
	}
	if (resultSeconds) {
		result.push(
			`${+resultSeconds} ${getNumericDeclension(+resultSeconds, {
				single: 'секунда',
				some: 'секунды',
				many: 'секунд'
			})}`
		);
	}
	return result.join(' ');
};
